// External
import React, { useEffect, useState } from 'react';
import { Box } from 'rebass';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { func, object, string } from 'prop-types';
import { Formik } from 'formik';

// Components
import CatalogsCreateOrEditForm from './CatalogsCreateOrEditForm';
import CatalogsEditReadOnly from './CatalogsEditReadOnly';
import CatalogProductsList from '../../catalogs/catalogsCreateOrEdit/CatalogProductsList';

// Functions
import { saveCatalog, fetchCatalogById, fetchSeasons } from '../actions';
import { fetchCatalogTypes } from '../../catalogTypes/actions';

import { getCatalogById } from '../selectors';

// Constants
import { getInitialValues, validationSchema } from '../constants';
import { isDirectShip } from '../utils';
import Page from '../../../../src/admin/common/Page';

export const CatalogsCreateOrEdit = ({
  currentCatalog,
  currentCatalogId,
  saveCatalog,
  fetchCatalogById,
  fetchSeasons,
  fetchCatalogTypes
}) => {
  const isEditing = !!currentCatalogId;

  const history = useHistory();

  const [hasClickedEditIcon, setHasClickedEditIcon] = useState(false);

  useEffect(async () => {
    if (isEditing) {
      await fetchCatalogById(currentCatalogId);
    }
  }, [isEditing]);

  useEffect(async () => {
    await fetchSeasons();
    await fetchCatalogTypes();
  }, []);

  const submit = async values => {
    const filteredValues = { ...values };
    filteredValues.directShip = isDirectShip(values) ? false : values.directShip;

    const fieldsToNull = [
      'atOnceEnd',
      'atOnceStart',
      'forecastCrd',
      'forecastEnd',
      'forecastStart',
      'futuresCrd',
      'futuresEnd',
      'futuresStart'
    ];

    for (let i = 0; i < fieldsToNull.length; i++) {
      const currField = fieldsToNull[i];
      const value = filteredValues[currField];

      if (!value) filteredValues[currField] = null;
    }

    Object.assign(
      filteredValues,
      ...['name', 'groupName'].map(field => ({ [field]: filteredValues[field].toUpperCase() }))
    );

    const newCatalogId = await saveCatalog({ payload: filteredValues, catalogId: filteredValues.id });

    if (filteredValues.id) {
      setHasClickedEditIcon(false);
    } else if (!isEditing && !!newCatalogId) {
      history.push(`/catalogs/edit/${newCatalogId}`);
    }
  };

  const handleCancel = () => {
    if (isEditing) {
      setHasClickedEditIcon(false);
    } else {
      history.goBack();
    }
  };
  return (
    <Page
      title={isEditing ? `Edit Catalog: ${currentCatalog.name || ''}` : 'Create Catalog'}
      HeaderContent={
        isEditing &&
        !hasClickedEditIcon && (
          <Box p='10px' width='100%'>
            <CatalogsEditReadOnly setHasClickedEditIcon={setHasClickedEditIcon} catalog={currentCatalog} />
          </Box>
        )
      }
      linkBack={{ url: '/catalogs', linkTitle: 'Catalogs' }}
      noPadding
      noExtraPadding
    >
      {(hasClickedEditIcon || !isEditing) && (
        <Formik initialValues={getInitialValues(currentCatalog)} validationSchema={validationSchema} onSubmit={submit}>
          <CatalogsCreateOrEditForm onCancel={handleCancel} isEditing={isEditing} />
        </Formik>
      )}
      {!hasClickedEditIcon && currentCatalogId && (
        <CatalogProductsList currentCatalog={currentCatalog} catalogId={currentCatalogId} />
      )}
    </Page>
  );
};

CatalogsCreateOrEdit.propTypes = {
  saveCatalog: func.isRequired,
  currentCatalog: object.isRequired,
  currentCatalogId: string,
  fetchCatalogById: func.isRequired,
  fetchSeasons: func.isRequired,
  fetchCatalogTypes: func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const currentCatalogId = ownProps?.match?.params?.currentCatalogId;

  return {
    currentCatalog: getCatalogById(state, currentCatalogId),
    currentCatalogId
  };
};

CatalogsCreateOrEdit.defaultProps = {
  currentCatalogId: null
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    saveCatalog,
    fetchCatalogById,
    fetchCatalogTypes,
    fetchSeasons
  })
)(CatalogsCreateOrEdit);
